import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { MotionListStyled } from './styled';

import clsx from 'clsx';
import { get, ref, set } from 'firebase/database';
import Button from 'src/components/Button';
import MotionCard from 'src/components/MotionCard';
import database from 'src/libraries/firebase';
import { kindToName } from 'src/libraries/health';

interface MotionListProps {
  className?: string;
}

const tempHistory = [
  {
    kind: 1,
    set: 1,
    success: 8,
    fail: 2,
  },
  {
    kind: 1,
    set: 2,
    success: 9,
    fail: 1,
  },
  {
    kind: 2,
    set: 1,
    success: 8,
    fail: 2,
  },
  {
    kind: 2,
    set: 2,
    success: 9,
    fail: 1,
  },
];

const MotionList = ({ className }: MotionListProps) => {
  const navigate = useNavigate();
  const [historys, setHistorys] = useState(
    JSON.parse(localStorage.getItem('history') || '[]'),
  );

  return (
    <MotionListStyled className={clsx('MotionList', className)}>
      {tempHistory.map((history: any, index: number) => (
        <MotionCard
          key={index}
          title={`${kindToName(history.kind)} ${history.set} 세트`}
          success={history.success}
          fail={history.fail}
        />
      ))}
      <div className="action-button">
        <Button
          block
          size="large"
          onClick={async () => {
            const robotSettingRef = ref(
              database,
              'health_robot/setting/status',
            );
            await set(robotSettingRef, 'PENDING');
            navigate('/');
          }}
        >
          돌아가기
        </Button>
      </div>
    </MotionListStyled>
  );
};

export default MotionList;
